module.exports = __webpack_public_path__ + "img/taste-parallax2.c90baefd.jpg";